import React from 'react'
import { CreateUserPermissionsFlowProvider } from './context/CreateUserPermissionsFlowProvider'
import { CreateUserPermissionsFlowMain } from './components/CreateUserPermissionsFlowMain'

export const CreateUserPermissionsFlow = () => {
  return (
    <CreateUserPermissionsFlowProvider>
      <CreateUserPermissionsFlowMain />
    </CreateUserPermissionsFlowProvider>
  )
}
